// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1-mNE","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__28d_C"};